/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Editors_Eyebrow_EquipmentInputs */

const en_us2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipment`)
};

const pt_br2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const es_419_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo`)
};

const pt_pt2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipamento`)
};

const fr_fr2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Matériel`)
};

const de_de2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausrüstung`)
};

const it_it2_profile_editors_eyebrow_equipment = /** @type {(inputs: Profile_Editors_Eyebrow_EquipmentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Attrezzatura`)
};

/**
* | output |
* | --- |
* | "Equipment" |
*
* @param {Profile_Editors_Eyebrow_EquipmentInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_editors_eyebrow_equipment = /** @type {((inputs?: Profile_Editors_Eyebrow_EquipmentInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Editors_Eyebrow_EquipmentInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_editors_eyebrow_equipment(inputs)
	if (locale === "es-419") return es_419_profile_editors_eyebrow_equipment(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_editors_eyebrow_equipment(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_editors_eyebrow_equipment(inputs)
	if (locale === "de-DE") return de_de2_profile_editors_eyebrow_equipment(inputs)
	if (locale === "it-IT") return it_it2_profile_editors_eyebrow_equipment(inputs)
	return en_us2_profile_editors_eyebrow_equipment(inputs)
});
export { profile_editors_eyebrow_equipment as "profile-editors.eyebrow_equipment" }